import { render, staticRenderFns } from "./protocols.vue?vue&type=template&id=ac09cd4a&"
import script from "./protocols.vue?vue&type=script&lang=js&"
export * from "./protocols.vue?vue&type=script&lang=js&"
import style0 from "./protocols.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
